import React from "react";
import LanImg from "../../../../assets/images/LAN.png";

import './styles.css';

const Lan = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="siglas-title">
                    <h1>LAN</h1>
                </div>
                <div className="col-sm-12">
                    <div className="siglas">
                        <img src={LanImg} alt="siglas" />
                    </div>
                </div>                
            </div>
        </div>
    );
};
export default Lan;